var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"menu-pc"},_vm._l((_vm.mItems),function(item,index){return _c('li',{key:index},[_c('a',{class:`menu_${item.id}`,attrs:{"href":item.link}},[_vm._v("\n      "+_vm._s(item.label)+"\n    ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }